import React from "react";
import "./Pricing.css";

const features = [
  {
    icon: <i className="fa-solid fa-location-dot" />,
    title: "Distance-Based Pricing",
    desc: "Pay for the distance from pickup to destination — no hidden charges."
  },
  {
    icon: <i className="fa-solid fa-truck" />,
    title: "Truck-Based Rates",
    desc: "Pricing varies by truck size — from Pickup to 20-ton, pick what you need."
  },
  {
    icon: <i className="fa-solid fa-lock" />,
    title: "Escrow Protection",
    desc: "Payment is held securely and released only after delivery is confirmed."
  },
  {
    icon: <i className="fa-solid fa-receipt" />,
    title: "eTIMS Receipts",
    desc: "Every order generates a tax-compliant digital receipt, including KRA eTIMS for applicable jurisdictions."
  },
  {
    icon: <i className="fa-solid fa-bolt" />,
    title: "Instant Quotes",
    desc: "Get a real-time price quote before you confirm any booking."
  },
  {
    icon: <i className="fa-solid fa-chart-bar" />,
    title: "Corporate Contracts",
    desc: "Lock in competitive long-term rates with a dedicated contract."
  },
];

export default function Pricing() {
  return (
    <div>
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="page-hero-label">Pricing</span>
        <h1>Transparent Pricing, Always</h1>
        <p>
          No hidden fees. No surprises. Every price is calculated upfront based on
          distance and truck type — you confirm before you commit.
        </p>
      </div>

      <div className="pricing-body">
        {/* MAIN PRICING CARD */}
        <div className="pricing-card">
          <span className="pricing-card-label">Starting From</span>
          <h3>Minimum Fare</h3>

          <div className="pricing-amount">
            1,000
          </div>
          <span className="pricing-unit">local currency / per delivery</span>

          <p>
            All deliveries start from a minimum fare equivalent to 1,000 units in your local currency. Final pricing is
            calculated based on the total distance and the truck category selected.
          </p>
        </div>

        {/* FEATURE GRID */}
        <div className="pricing-features">
          {features.map((f, i) => (
            <div className="pricing-feature" key={i}>
              <div className="pricing-feature-icon">{f.icon}</div>
              <div className="pricing-feature-text">
                <strong>{f.title}</strong>
                <span>{f.desc}</span>
              </div>
            </div>
          ))}
        </div>

        {/* BOTTOM NOTE */}
        <div className="pricing-note">
          For an exact quote, book through the{" "}
          <strong>Mr Truck app</strong> and receive an instant price before confirming your order.
        </div>
      </div>
    </div>
  );
}
